/*
 * @Author: zyy
 * @Date: 2022-03-28 10:51:12
 * @LastEditors: zyy
 * @LastEditTime: 2022-04-02 15:56:05
 * @Description: default
 */
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';

import Antd from 'ant-design-vue';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';

import Common from '@/plugins/common.js';

import '@/io/request.js';



  

Vue.use(Antd);
Vue.use(Viewer);
Vue.use(Common);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
